import {Can} from '../../permission/ability';
import {RIGHTS} from '@/views/roles/rights';

export function mayManageAppOnboarding() {
  return !Can(RIGHTS.IS_CUSTOMER) && (Can(RIGHTS.IS_ADMIN) || Can(RIGHTS.CUSTOMER_APP_ONBOARDING));
}

export function mayViewAppOnboarding() {
  return mayManageAppOnboarding() || (!Can(RIGHTS.IS_CUSTOMER) && Can(RIGHTS.CUSTOMER_APP_ONBOARDING_VIEW));
}
